import { fetchApi } from "../../utils";

const fetchLogin = (uid, password) => {
  const data = {
    uid: uid,
    password: password
  };
  return fetchApi("auth/login", "POST", JSON.stringify(data));
};

const fetchGetProfile = token => {
  const headers = {
    Authorization: `Bearer ${token}`
  };
  return fetchApi("auth/me", "GET", {}, headers);
};

export { fetchLogin, fetchGetProfile };



// WEBPACK FOOTER //
// ./src/services/page/auth.js